import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#1C1C1C] text-neutral-300 border-t border-neutral-800 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-neutral-800">
          {/* Company Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/6ff16b38-fa18-408f-9a5d-f4f108c00990/logo-8.png"
                alt="KELFAE LOFTER Logo"
                className="h-10 w-auto object-contain bg-white p-1 rounded-sm"
              />
            </Link>
            <p className="text-xs leading-relaxed text-neutral-400">
              KELFAE LOFTER ApS er en seriøs og kvalitetsbevidst B2B leverandør af akustiklofter, loftplader, T-skinnesystemer og tilbehør til professionelle bygherrer, arkitekter, entreprenører og tømrere i hele Danmark.
            </p>
            <div className="pt-2 text-xs font-semibold text-neutral-300">
              <span>CVR nr.: 19837688</span>
            </div>
          </div>

          {/* Quick Product Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-4 font-serif-heading">
              Produkter
            </h3>
            <ul className="space-y-2.5 text-xs">
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/parafon-mineraluld-rockwool" className="hover:text-[#7FDCA7] transition-colors">
                  Parafon Mineraluld / Rockwool
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/flaadeloft" className="hover:text-[#7FDCA7] transition-colors">
                  Flådeloft
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/amf-thermatex-loftplader" className="hover:text-[#7FDCA7] transition-colors">
                  AMF Thermatex loftplader
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/montagesystemer" className="hover:text-[#7FDCA7] transition-colors">
                  Montagesystemer
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/gitterlofter" className="hover:text-[#7FDCA7] transition-colors">
                  Gitterlofter
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/bafler" className="hover:text-[#7FDCA7] transition-colors">
                  Bafler
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/produkter/ventatec-og-donn-skinnesystem" className="hover:text-[#7FDCA7] transition-colors">
                  Ventatec og DONN Skinnesystem
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Info Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-4 font-serif-heading">
              Hvad kan vi hjælpe med?
            </h3>
            <ul className="space-y-2.5 text-xs">
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/om-os" className="hover:text-[#7FDCA7] transition-colors">
                  Om os
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/reference" className="hover:text-[#7FDCA7] transition-colors">
                  Referencer & Løsninger
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/montageanvisning" className="hover:text-[#7FDCA7] transition-colors">
                  Montageanvisning
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/galleri" className="hover:text-[#7FDCA7] transition-colors">
                  Galleri
                </Link>
              </li>
              <li className="border-b border-neutral-800 pb-1.5">
                <Link to="/kontakt" className="hover:text-[#7FDCA7] transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Warehouse Info */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-4 font-serif-heading">
              Kontakt os
            </h3>
            <div className="space-y-3 text-xs">
              <div>
                <p className="font-semibold text-white">KELFAE LOFTER ApS</p>
                <p>Vejleåvej 1</p>
                <p>2635 Ishøj</p>
              </div>

              <div className="pt-1 space-y-1">
                <p>
                  <a
                    href="tel:43712540"
                    className="hover:text-[#7FDCA7] transition-colors font-medium text-white whitespace-nowrap"
                  >
                    <i className="fa-solid fa-phone text-[#7FDCA7] mr-2" aria-hidden="true" />
                    (+45) 43 71 25 40
                  </a>
                </p>
                <p>
                  <a
                    href="mailto:jlh@kelfae.dk"
                    className="hover:text-[#7FDCA7] transition-colors whitespace-nowrap"
                  >
                    <i className="fa-regular fa-envelope text-[#7FDCA7] mr-2" aria-hidden="true" />
                    jlh@kelfae.dk
                  </a>
                </p>
              </div>

              <div className="pt-2 border-t border-neutral-800">
                <p className="font-semibold text-neutral-200">Afhentningslager:</p>
                <p className="text-neutral-400">Thurah Transport A/S (Terminalen)</p>
                <p className="text-neutral-400">Vejleåvej 1, 2635 Ishøj</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center text-xs text-neutral-400 gap-4">
          <p>© {new Date().getFullYear()} KELFAE LOFTER ApS. Alle rettigheder forbeholdes.</p>
          <p className="text-neutral-400 text-[11px]">
            Professionelle loft- og akustikløsninger til B2B
          </p>
        </div>
      </div>
    </footer>
  );
}
